import axios from 'axios';

export const acceptUpdateRequest = async ({ updateID }) => {
  const response = await axios.post('/admin/site/update/accept', {
    updateID,
  });
  return response.data;
};
